export default {
    invoices: state => state.invoices,
    invoice_items: state => state.invoice_items,
    invoice: state => state.invoice,
    invoice_items_expenses: state => state.invoice_items_expenses,
    invoice_items_timelogs: state => state.invoice_items_timelogs,
    invoice_items_milestones: state => state.invoice_items_milestones,
    invoice_metrics: state => state.invoice_metrics,
}
